export const LAB_TEST_REFERENCE_VALUES = {
  HEMATOLOGICAL_TEST: {
    wbc: { label: "WBC/TC", reference: "4000–11000 /cumm", min: 4000, max: 11000 },
    neutrophil: { label: "Neutrophil", reference: "40–75%", min: 40, max: 75 },
    lymphocyte: { label: "Lymphocyte", reference: "20–45%", min: 20, max: 45 },
    monocyte: { label: "Monocyte", reference: "2–10%", min: 2, max: 10 },
    basophil: { label: "Basophil", reference: "0–1%", min: 0, max: 1 },
    esr: { label: "ESR", reference: "1–20 mm/hr", min: 1, max: 20 },
    platelet: { label: "Platelet", reference: "1,50,000–4,00,000 /cumm", min: 150000, max: 400000 },
    bloodGroup: { label: "Blood Group", reference: "-" },
    hb: {
      label: "HB",
      reference: "Male: 12–18 g/dl, Female: 12–16 g/dl",
      genderSpecific: {
        MALE: { min: 12, max: 18 },
        FEMALE: { min: 12, max: 16 },
      },
    },
    rbc: { label: "RBC", reference: "3.0–6.0", min: 3.0, max: 6.0 },
    pcv: { label: "PCV", reference: "35–50%", min: 35, max: 50 },
  },
  BIOCHEMICAL_TEST: {
    sugarF: { label: "Sugar (F)", reference: "60–110 mg/dl", min: 60, max: 110 },
    sugarPP: { label: "Sugar (PP)", reference: "60–140 mg/dl", min: 60, max: 140 },
    sugarR: { label: "Sugar (R)", reference: "60–145 mg/dl", min: 60, max: 145 },
    sCreatinine: {
      label: "S. Creatinine",
      reference: "Male: 0.7–1.2 mg%, Female: 0.5–1.0 mg%",
      genderSpecific: {
        MALE: { min: 0.7, max: 1.2 },
        FEMALE: { min: 0.5, max: 1.0 },
      },
    },
    urea: { label: "Urea", reference: "10–45 mg/dl", min: 10, max: 45 },
    uricAcid: {
      label: "Uric Acid",
      reference: "Male: 3.4–7.0 mg%, Female: 2.4–5.7 mg%",
      genderSpecific: {
        MALE: { min: 3.4, max: 7.0 },
        FEMALE: { min: 2.4, max: 5.7 },
      },
    },
    calcium: { label: "Calcium", reference: "8.5–11.0 mg/dl", min: 8.5, max: 11.0 },
    amylase: { label: "Amylase", reference: "40–140 U/L", min: 40, max: 140 },
  },
  LIVER_FUNCTION_TEST: {
    bilirubinT: { label: "Bilirubin (T)", reference: "Up to 1.0 mg/dl", max: 1.0 },
    bilirubinD: { label: "Bilirubin (D)", reference: "Up to 0.3 mg/dl", max: 0.3 },
    sgot_ast: { label: "SGOT/AST", reference: "Up to 46 IU/L", max: 46 },
    albunmin: { label: "Albumin", reference: "3.5–5.0 gm/dl", min: 3.5, max: 5.0 },
  },
  LIPID_PROFILE_TEST: {
    totalCholesterol: { label: "Total Cholesterol", reference: "<200 mg/dl", max: 200 },
    hdlCholesterol: { label: "HDL Cholesterol", reference: "-" },
    ldlCholesterol: { label: "LDL Cholesterol", reference: "-" },
    triglyceride: { label: "Triglyceride", reference: "Up to 170 mg/dl", max: 170 },
    vldl: { label: "VLDL", reference: "-" },
  },
  URINE_TEST: {
    albumin: { label: "Albumin", reference: "-" },
    sugar: { label: "Sugar", reference: "-" },
    reaction: { label: "Reaction", reference: "-" },
  },
  IMMUNOLOGY_TEST: {
    crp: { label: "CRP", reference: "-" },
    hiv: { label: "HIV", reference: "-" },
    hbsag: { label: "HBsAg", reference: "-" },
    vdrl: { label: "VDRL", reference: "-" },
    rafactor: { label: "RA Factor", reference: "-" },
    hcv: { label: "HCV", reference: "-" },
    hav: { label: "HAV", reference: "-" },
    hev: { label: "HEV", reference: "-" },
    asoTire: { label: "ASO Titer", reference: "-" },
    widalTest: { label: "Widal Test", reference: "-" },
    salmonellaTyphilO: { label: "Salmonella Typhi O", reference: "-" },
    salmonellaTyphiH: { label: "Salmonella Typhi H", reference: "-" },
    salmonellaParaAH: { label: "Salmonella Para A (H)", reference: "-" },
    salmonellaParaBH: { label: "Salmonella Para B (H)", reference: "-" },
    hPyloriAntibody: { label: "H. Pylori Antibody", reference: "-" },
    hPyloriAntigen: { label: "H. Pylori Antigen", reference: "-" },
  },
  MICROSCOPIC_TEST: {
    pus: { label: "Pus", reference: "-" },
    rbcs: { label: "RBCs", reference: "-" },
    epiCells: { label: "Epithelial Cells", reference: "-" },
    caOxalate: { label: "Ca. Oxalate", reference: "-" },
  },
  STOOL_TEST: {
    appearance: { label: "Appearance", reference: "-" },
    wbc: { label: "WBC", reference: "-" },
    rbc: { label: "RBC", reference: "-" },
    microscopy: { label: "Microscopy", reference: "No Ova, Cysts or Parasites Seen" },
  },
};

export const isAbnormalResult = (key, value, reportTemplate, gender) => {
  if (value === null || value === undefined || value === "") return false;

  const numValue = Number(value);
  if (isNaN(numValue)) return false;

  const refConfig = LAB_TEST_REFERENCE_VALUES[reportTemplate]?.[key];
  if (!refConfig) return false;

  let min = refConfig.min;
  let max = refConfig.max;

  if (refConfig.genderSpecific && gender) {
    const genderRange = refConfig.genderSpecific[gender];
    if (genderRange) {
      min = genderRange.min;
      max = genderRange.max;
    }
  }

  if (min !== undefined && min !== null && numValue < min) return true;
  if (max !== undefined && max !== null && numValue > max) return true;

  return false;
};
